import { useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
    window.addEventListener('online', onChange);
    window.addEventListener('offline', onChange);
    return () => {
        window.removeEventListener('online', onChange);
        window.removeEventListener('offline', onChange);
    };
};

/** Ob der Browser eine Netzverbindung meldet; aktualisiert sich bei jedem Wechsel. */
export const useOnlineStatus = (): boolean =>
    useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
